module.exports = __webpack_public_path__ + "static/media/forward-w-icon.035a916b.svg";